// Shared UTC date/time formatting helpers
// Ensures all displayed dates are in UTC and explicitly labeled "UTC".

export type UtcFormat = "datetime" | "date" | "time";

export function formatUTC(
  value: string | number | Date | null | undefined,
  type: UtcFormat = "datetime"
): string {
  if (value === null || value === undefined || value === "") return "";
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return "";

  switch (type) {
    case "date": {
      // e.g., 26 Aug 2025 (date only: no explicit UTC label)
      const s = d.toLocaleDateString("en-GB", {
        timeZone: "UTC",
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
      return s;
    }
    case "time": {
      // e.g., 14:05 UTC
      const s = d.toLocaleTimeString("en-GB", {
        timeZone: "UTC",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
      return `${s} UTC`;
    }
    case "datetime":
    default: {
      // dd/mm/yyyy hh:MM:ss UTC (24-hour)
      const dd = String(d.getUTCDate()).padStart(2, "0");
      const MM = String(d.getUTCMonth() + 1).padStart(2, "0");
      const yyyy = d.getUTCFullYear();
      const hh = String(d.getUTCHours()).padStart(2, "0");
      const mm = String(d.getUTCMinutes()).padStart(2, "0");
      const ss = String(d.getUTCSeconds()).padStart(2, "0");
      return `${dd}/${MM}/${yyyy} ${hh}:${mm}:${ss} UTC`;
    }
  }
}

export function formatUTC_DDMM(
  value: string | number | Date | null | undefined
): string {
  // Compact dd/mm in UTC (date only: no explicit UTC label)
  if (value === null || value === undefined || value === "") return "";
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return "";
  const day = String(d.getUTCDate()).padStart(2, "0");
  const month = String(d.getUTCMonth() + 1).padStart(2, "0");
  return `${day}/${month}`;
}
